export default "__VITE_ASSET__Dh5o1av4__"